import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
export default theme => ({
  root: {
    '& .hoi-poi-ui__tabs-nav-scroll': {
      width: 'auto !important',
      overflow: 'hidden',
      '& .hoi-poi-ui__tabs-nav': {
        display: 'block',
        height: 39
      }
    }
  },
  tabsRoot: {
    padding: '0 20px'
  },
  shrinkedTab: _objectSpread({
    whiteSpace: 'nowrap',
    flex: 1,
    minWidth: 210,
    padding: '5px 0 16px 0',
    marginLeft: 20
  }, theme.typography.defaultText),
  activeShrinkedTab: {
    '& $shrinkedTabText': {
      '&::after': {
        zIndex: 1,
        boxSizing: 'border-box',
        backgroundColor: theme.colors.utility.textPrimary,
        height: 2,
        top: '32px',
        left: 0,
        right: 0,
        content: '""',
        position: 'absolute'
      }
    }
  },
  shrinkedTabSelect: {
    overflow: 'hidden',
    zIndex: 100,
    '& .hoi-poi-select__menu': {
      position: 'relative',
      boxShadow: 'none !important',
      marginBottom: 0
    }
  },
  shrinkedTabText: _objectSpread(_objectSpread({
    position: 'relative',
    transition: 'color 0.3s cubic-bezier(0.35, 0, 0.25, 1)',
    lineHeight: '20px',
    cursor: 'pointer'
  }, theme.typography.defaultText), {}, {
    color: theme.colors.utility.textSecondary,
    '&:hover': {
      '& $shrinkedTabText': {
        color: theme.colors.utility.textPrimary
      }
    }
  })
});